import React from 'react';
import { Switch, Redirect, Route, withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import { AdminRoute } from '../components/layout/routes/AdminRoute';
import { authStore } from '../shared/security/AuthStore';
import { Notifications } from '../components/layout/notifications/Notifications';
import { Dialog } from '../components/layout/modals/Dialog';
import { Modal } from '../components/layout/modals/Modal';
import { ServiceTerms } from 'components/documents/ServiceTerms';
import { PrivacyPolicy } from 'components/documents/PrivacyPolicy';
import { CandidatePublicProfileRedirect } from '../components/candidates/profile/public/CandidatePublicProfileRedirect';
import { CandidatePublicProfile } from 'candidate-public-profile/CandidatePublicProfile';
import ATSApp from './ATSApp';
import { LinkedInImporterPrivacy } from 'components/documents/LinkedInImporterPrivacy';
import { getDefaultAtsPath } from 'shared/security/rolePermissions';
import OpenJobs from 'ats/pages/open-jobs/OpenJobs';

@withRouter
@observer
export class AdminApp extends React.Component {
	render() {
		return (
			<div className="App">
				<Notifications />
				<Dialog />
				<Modal />
				<Switch>
					<Redirect exact from="/" to={getDefaultAtsPath()} />
					<AdminRoute
						fullScreenLayout={true}
						path="/linkedin-importer/privacy-policy"
						exact
						hiddenFooter>
						<LinkedInImporterPrivacy />
					</AdminRoute>
					<AdminRoute
						fullScreenLayout={true}
						path="/profile"
						exact
						hiddenFooter>
						<CandidatePublicProfile />
					</AdminRoute>
					<AdminRoute
						path="/jobs/:id?"
						fullScreenLayout={true}
						exact
						hiddenFooter>
						<OpenJobs />
					</AdminRoute>
					<AdminRoute path="/terms" exact fullScreenLayout={true}>
						<ServiceTerms />
					</AdminRoute>
					<AdminRoute fullScreenLayout={true} path="/privacy-policy" exact>
						<PrivacyPolicy />
					</AdminRoute>
					{/* Legacy redirect */}
					<AdminRoute fullScreenLayout={true} path="/p/:slug" exact>
						<CandidatePublicProfileRedirect />
					</AdminRoute>
					<Route path="/ats" fullScreenLayout={false}>
						{auth(<ATSApp />)}
					</Route>
					{/* Default */}
					<Redirect to="/" />
				</Switch>
			</div>
		);
	}
}

function auth(component) {
	if (!authStore.isUserLogged()) {
		return <Redirect to="/login" />;
	} else {
		return component;
	}
}
